// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2C5X1","alertIcon":"ConfirmModal_alertIcon__1YBi6"};